import type { PromotionsBanner } from 'shared/src/api';
import { convertHexToContentColorKeys, Typography } from '@banhala/ui-kit';
import { isNil } from 'shared/src/utils';
import { useRemainTimeTextFormat } from '../../../hooks/useRemainTimeTextFormat';

export const RemainTimer: React.FC<{
  timer: PromotionsBanner['item']['timer'];
}> = props => {
  const { isTimeOver, text } = useRemainTimeTextFormat(
    props.timer?.expired_at ?? null,
  );

  if (isNil(props.timer)) return null;

  if (isTimeOver) return null;

  return (
    <Typography
      type={'subtitle4'}
      color={convertHexToContentColorKeys(props.timer.text_color) ?? undefined}
      rawColor={
        convertHexToContentColorKeys(props.timer.text_color)
          ? undefined
          : props.timer.text_color
      }
    >
      {text} 남음
    </Typography>
  );
};
